export default __webpack_public_path__ + "static/media/undraw_Security_on_re_e491.ff17c213.png";